export default __webpack_public_path__ + "static/media/Giuria (2).fdbc0901.jpg";